<sds-subheader>
  <!--  Back button  -->
  <button class="sds-button sds-button--circular" aria-label="Back to Profile" (click)="navigateTo('/workspace')">
    <usa-icon [icon]="'chevron-left'"></usa-icon>
  </button>

  <!--  Title  -->
  <span class="sds-navbar__title">
    {{
      _document.getElementsByTagName('sam-frontend-admin-request-feeds')[0] ||
      _document.getElementsByTagName('sam-frontend-admin-requestor-side')[0]
        ? 'Requests'
        : 'Profile'
    }}
  </span>
</sds-subheader>

<section id="main-container" tabindex="-1" class="outline-0 grid-row grid-container">
  <div
    *ngIf="hideProfileNav(_document)"
    class="desktop:grid-col-3 grid-col-12"
    [class.display-none]="showUserDetailsUpdate"
  >
    <sam-frontend-admin-navigation [isGov]="authService?.getUser()?.isGov"></sam-frontend-admin-navigation>
  </div>

  <div
    [class]="{ 'grid-col-12': showFeedsNav(_document), 'desktop:grid-col-9': hideProfileNav(_document) }"
    [class.display-none]="showUserDetailsUpdate"
  >
    <div *ngIf="hideUserHeader(_document)">
      <sam-frontend-admin-username-header></sam-frontend-admin-username-header>
    </div>
    <router-outlet></router-outlet>
  </div>

  <div *ngIf="showUserDetailsUpdate" class="grid-col-12">
    <sam-account-details-update
      [user]="userData"
      [orgData]="serviceUtils?.orgData"
      (onUpdate)="accountDetailsUpdate($event)"
      (onCancel)="accountDetailsUpdate($event)"
    ></sam-account-details-update>
  </div>
</section>
